import { Link } from "@tanstack/react-router";
import logo from "@/assets/quibblies-logo.png";


const COLUMNS = [
  {
    title: "Explore",
    links: [
      { to: "/discover", label: "Discover writing" },
      { to: "/categories", label: "Categories" },
      { to: "/auth", label: "Join Quibblies" },
    ],
  },
  {
    title: "Community",
    links: [
      { to: "/about", label: "About" },
      { to: "/guidelines", label: "Community guidelines" },
      { to: "/help", label: "Help Centre" },
      { to: "/support", label: "Support & FAQ" },
      { to: "/contact", label: "Contact" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/terms", label: "Terms of use" },
      { to: "/privacy", label: "Privacy" },
      { to: "/tipping", label: "Tipping & platform fee" },
      { to: "/copyright", label: "Copyright & removal" },
    ],
  },
] as const;

export function SiteFooter() {
  return (
    <footer className="mt-24 border-t border-border/60 bg-surface/40">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6">
        <div className="grid gap-10 md:grid-cols-[1.4fr_repeat(3,1fr)]">
          <div>
            <Link to="/" className="flex items-center gap-2" aria-label="Quibblies home">
              <img
                src={logo}
                alt="Quibblies"
                loading="lazy"
                width={816}
                height={816}
                className="h-9 w-9 object-contain"
              />
              <span className="font-display text-xl tracking-tight text-foreground">Quibblies</span>
            </Link>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-muted-foreground">
              An 18+ writing, storytelling and self-expression community. Accounts, profile media
              and writing are each reviewed by people before they go live.
            </p>
            <p className="mt-3 text-sm text-muted-foreground">
              <a
                href="mailto:quibbliessupport@gmail.com"
                className="transition-smooth hover:text-foreground"
              >
                quibbliessupport@gmail.com
              </a>
            </p>
          </div>

          {COLUMNS.map((column) => (
            <nav key={column.title} aria-label={column.title}>
              <p className="text-xs font-semibold uppercase tracking-widest text-foreground">
                {column.title}
              </p>
              <ul className="mt-4 space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.to + link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-muted-foreground transition-smooth hover:text-foreground"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-border/60 pt-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Quibblies. All writing belongs to its authors.</p>
          <p>
            Reader tips carry a 5% Quibblies platform fee. Once a tip has been paid out to the
            writer it is non-refundable and Quibblies is not responsible for recovering it.{" "}
            <Link to="/tipping" className="underline underline-offset-4 hover:text-foreground">
              Read the tipping policy
            </Link>
            .
          </p>

        </div>
      </div>
    </footer>
  );
}
